var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.880487 10.2941C0.318422 9.31241 0 8.19105 0 7C0 5.83914 0.302406 4.74461 0.83859 3.78066L0.853227 3.75443C2.10644 1.5227 4.61277 0 7.5 0C9.31974 0 10.9883 0.604981 12.2874 1.6115L9.85751 3.46812C9.17389 3.06916 8.36574 2.83869 7.5 2.83869C5.55266 2.83869 3.89691 4.0042 3.28934 5.62847L3.28223 5.64758C3.12652 6.07159 3.04145 6.52659 3.04145 7C3.04166 7.5138 3.14126 8.00622 3.32424 8.46033V8.46053C3.95769 10.0382 5.5883 11.1613 7.5 11.1613C8.32173 11.1613 9.09148 10.9539 9.75208 10.592L9.77255 10.5807C10.6397 10.1001 11.3172 9.35379 11.6753 8.46162H7.66494V5.69233H14.869C14.9552 6.11574 15 6.55312 15 7C15 7.50113 14.9436 7.99009 14.836 8.46162C14.4723 10.06 13.5244 11.4563 12.2108 12.4472L12.1953 12.4588C10.91 13.4231 9.27731 14 7.5 14C4.64385 14 2.16065 12.5101 0.893852 10.3172L0.880487 10.2941Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.d2c4af09.svg";
export { ForwardRef as ReactComponent };